import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { formatError } from "@/lib/api";
import { Spinner } from "@/components/Field";

export function useSubmit() {
  const [saving, setSaving] = useState(false);
  const run = async (fn, success) => {
    setSaving(true);
    try {
      const r = await fn();
      if (success) toast.success(success);
      return r;
    } catch (e) {
      toast.error(formatError(e));
      throw e;
    } finally {
      setSaving(false);
    }
  };
  return { saving, run };
}

export const FormDialog = ({ open, onOpenChange, title, description, onSubmit, submitLabel = "Salva", saving, children, testId, wide }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid={testId} className={`${wide ? "sm:max-w-2xl" : "sm:max-w-lg"} max-h-[92vh] overflow-y-auto`}>
      <DialogHeader>
        <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
        {description && <DialogDescription>{description}</DialogDescription>}
      </DialogHeader>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit().catch(() => {});
        }}
        className="space-y-4"
      >
        {children}
        <DialogFooter className="gap-2 pt-2">
          <Button type="button" variant="outline" className="h-11" onClick={() => onOpenChange(false)} data-testid={`${testId}-cancel`}>Annulla</Button>
          <Button type="submit" className="h-11 min-w-[120px]" disabled={saving} data-testid={`${testId}-submit`}>
            {saving ? <Spinner className="h-4 w-4" /> : submitLabel}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const num = (v) => (v === "" || v == null ? null : Number(v));
export const clean = (obj) => Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v === "" ? null : v]));
